import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { OpenDateNotReached } from '../../../errors/result/open-date-not-reached';
import { PickUpdaterBase } from './pick-updater';

export default class BetslipErrorOpenDateNotReachedUpdater extends PickUpdaterBase<OpenDateNotReached> {
    protected updateV1Pick(pick: BetslipV1Pick, _: OpenDateNotReached): void {
        pick.setMarketInvisible();
    }

    protected updateV2Pick(pick: BetslipV2Pick, _: OpenDateNotReached): void {
        pick.setMarketInvisible();
    }

    protected updateGroupPick(pick: BaseBetslipGroupPick, _: OpenDateNotReached): void {
        pick.isSuspended = true;
    }
}
